<template>
	<div class="page">
		<div class="searchBox">
			<el-form>
				<el-row>
					<el-col :span="3">
						<el-form-item>
							<span style="font-size: 18px;">印章详情</span>
						</el-form-item>
					</el-col>
					<el-col :span="2" :offset="19">
						<el-form-item style="text-align: right;">
							<el-button type="warning" @click="back">返回</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="contentBox">
			<div class="msgBox">
				<div class="msgImg">
					<img class="img" :src="detail.sealUrl"/>
				</div>
				<div class="msgImgR">
					<div class="msgLine" style="font-weight: bold;">{{detail.sealName||'--'}}</div>
					<div class="msgLine">
						印章类型：
						<span v-if="detail.sealType===1">公章</span>
						<span v-if="detail.sealType===2">合同章</span>
						<span v-if="detail.sealType===3">法人章</span>
						<span v-if="detail.sealType===4">财务章</span>
						<span v-if="detail.sealType===5">发票章</span>
						<span v-if="detail.sealType===6">其他用章</span>
					</div>
					<!-- <div class="msgLine">印章编号：{{detail.sealName}}</div> -->
					<div class="msgLine">生成时间：{{$public.FTime(detail.createTime)}}</div>
				</div>
			</div>
			<div class="tableBox">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column label="序号" width="50">
						<template slot-scope="props">
							{{parseInt(props.$index+1)}}
						</template>
					</el-table-column>
					<el-table-column label="文件编号" prop="contractNum" >
					</el-table-column>
					<el-table-column label="业务类型" prop="medicalServiceName" >
						<template slot-scope="props">
							<span v-if="props.row.contractType===2">洗美</span>
							<span v-if="props.row.contractType===6">寄养</span>
							<span v-if="props.row.contractType===5">医疗服务</span>
							<span v-if="props.row.contractType===8">活体</span>
							<span v-if="props.row.contractType===3">病例</span>
						</template>
					</el-table-column>
					<el-table-column label="顾客" prop="memberName" >
					</el-table-column>
					<el-table-column label="手机号" prop="memberMobile" >
					</el-table-column>
					<el-table-column label="宠物" prop="petName" >
					</el-table-column>
					<el-table-column label="签署状态" prop="birthDay" >
						<template slot-scope="props">
							<span v-if="props.row.state===2">已失效</span>
							<span v-if="props.row.state===1">
								<span v-if="props.row.signState===1">待签署</span>
								<span v-if="props.row.signState===2">已签署</span>
								<span v-if="props.row.signState===3">已领走</span>
							</span>
						</template>
					</el-table-column>
					<el-table-column label="创建时间" prop="typeName" >
						<template slot-scope="props">
							<div>{{$public.FTime(props.row.createTimeStamp,'YYYY-MM-DD')}}</div>
						</template>
					</el-table-column>
					<el-table-column label="签署时间" >
						<template slot-scope="props">
							<div>{{$public.FTime(props.row.signTime,'YYYY-MM-DD')}}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="60">
						<template slot-scope="props">
							<el-button type="text" size="mini" @click="see(props.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
				
			</div>
		</div>
		<div class="pagePosi">
			<page style="padding:10px 0;" :page="page.page" :total="page.total" :pageSize="page.pageSize" @change="changePage"></page>
		</div>
	</div>
</template>
<script>
	import page from "../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				detail:{},
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData:[],
				
			}
		},
		computed:{
		},
		mounted(){
			this.getDetail();
		},
		methods: {
			back(){
				this.$router.back()
			},
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getDetail(){
				let loading = this.$loading();
				this.$http.get(process.env.VUE_APP_business+'/api/Contract/Seal/Detail', {id:this.$route.query.id}).then(res => {
					loading.close()
					if (res.code == 0) {
						this.detail = res.data;
						this.page.page=1;
						this.getTableData();
					}
				})
			},
			getTableData(){
				let params = {
					isLink:-1,
					sealId:this.detail.id,
					desc:true,
					pageIndex:this.page.page,
					pageSize:this.page.pageSize,
				}
				let loading = this.$loading();
				this.$http.post(process.env.VUE_APP_business+'/api/Contract/Order/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 查看
			see(row){
				let loading = this.$loading();
				this.$http.get(process.env.VUE_APP_business+'/api/Contract/Order/Detail', {contractNum:row.contractNum}).then(res => {
					loading.close()
					if (res.code == 0) {
						window.open(res.data.signContractPdfUrl)
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.page{
	padding: 16px 16px 65px 16px;
	height: 100%;
	box-sizing: border-box;
	position: relative;
	.searchBox {
		.el-form-item {
			margin-bottom: 0;
		}
	}
	.contentBox{
		margin-top:12px;background-color: #fff;
		.msgBox{
			display: flex;padding:16px;
			.msgImg{
				width:252px;height: 195px;border:1px solid #d5d5d5;display: flex;align-items: center;justify-content: center;
				.img{
					width:155px;height: 150px;
				}
			}
			.msgImgR{
				padding-left:15px;padding-top:15px;
				.msgLine{
					font-size: 16px;color:#2a2a2a;padding-top:20px;
				}
			}
		}
		.tableBox{
			padding-top:30px;
		}
	}
	.pagePosi {
		bottom: 0;
		left: 16px;
		right: 16px;
		text-align: right;
		background-color: #fff;
		padding: 0 10px;
	}
}
</style>
